// import React, { useState, useEffect } from 'react'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom/dist';
import AddTaacaaIntegration from '../../core/modals/integrations/addtaacaaintegration';
import Swal from 'sweetalert2';
import Table2 from '../../core/pagination/datatable2'
import { PlusCircle  } from 'feather-icons-react/build/IconComponents';
import withReactContent from 'sweetalert2-react-content';
import {set_gateway_list, set_gateway_edit, set_page_refresh} from "../../core/redux/action";
import axios from 'axios';

const TaacaaIntegration = () => {
    const dispatch = useDispatch();
    const pageRefresh = useSelector((state) => (state.pageRefresh?.paymentConfigs || 0));
    const l = useSelector((state) => state.language || "en");
    const t = useSelector((state) => state.translation || "en");

    useEffect(() => {
        async function fetchData() {
          let result = await axios.get("getcardatascrapper/");
          dispatch(set_gateway_list(result.data.items))
        }

        fetchData()
        
      }, [pageRefresh])
    const dataSource = useSelector((state) => state.gateway_list);
    const permissions = useSelector(state => state.permissions) || [];
    const roleTitle = useSelector(state => state.roleTitle) || '';
    const roleTitleAdmin = useSelector(state => state.roleTitleAdmin) || '';

    const canView = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'view');
    const canCreate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'create');
    const canUpdate = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'update');
    const canDelete = roleTitle === roleTitleAdmin || permissions.some(p => p.Module.toLowerCase() === 'brands' && p.Permission.toLowerCase() === 'delete');

    if (!canView) {
        return ( 
        <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}><div className="content"><p>{t?.[l]?.["no_permission"] || "You do not have permission to view this page."}</p></div></div>
    )}

    const columns = [
        {
            title: t?.[l]?.["country"] || "Country",
            dataIndex: "country",
            render: (country) => country?.name || country,
        },

        {
            title: t?.[l]?.["maker"] || "Maker",
            dataIndex: "subCategoryNames",
            render: (subCategoryNames) => {
                if (!Array.isArray(subCategoryNames)) {
                    return t?.[l]?.["no_maker_details"] || "No Maker Details";
                }
                return subCategoryNames
                    .map(maker => t?.[l]?.[maker] || maker)
                    .join(", ");
            },
        },
        {
            title: t?.[l]?.["model"] || "Model",
            dataIndex: "modelNames",
            render: (modelNames) => {
                if (!Array.isArray(modelNames)) {
                    return t?.[l]?.["no_model_details"] || "No Model Details";
                }
                return modelNames
                    .map(model => t?.[l]?.[model] || model)
                    .join(", ");
            },
        },

       {
        title: t?.[l]?.["years"] || "Years",
        dataIndex: "carYears",
        render: (carYears) => {
            if (!Array.isArray(carYears)) {
            return t?.[l]?.["no_year_details"] || "No Year Details";
            }
            return carYears
            .slice() // make a copy so original data isn’t mutated
            .sort((a, b) => Number(a) - Number(b)) // ascending order
            .map(year => t?.[l]?.[year] || year)
            .join(", ");
            },
        },


        {
            title: t?.[l]?.["action"] || 'Actions',
            dataIndex: 'actions',
            key: 'actions',
            render: (text, record) => (
                <td className="action-table-data">
                    <div className="edit-delete-action">
                    {canUpdate && (
                        <Link className="me-2 p-2" to="#" data-bs-toggle="modal" data-bs-target="#add-brand" onClick={() => {editBrand(record)}}>
                            <i data-feather="edit" className="feather-edit"></i>
                        </Link>
                        )}
                            {canDelete && (
           
                <Link className="me-2 p-2" to="#"
                onClick={(e) => {
                 e.preventDefault(); // Prevent the default anchor behavior
                 showConfirmationAlert(record);
               }}>
                <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
                   
                        )}
               
               
                    </div>
                </td>
            )
        },
    ]
    const MySwal = withReactContent(Swal);

    const editBrand = async (record) => {
        dispatch(set_gateway_edit(null))    
        setTimeout(() => {
            dispatch(set_gateway_edit(record)); // Set the new state
        }, 0); // Ensure React recognizes the state change
    }
    const showConfirmationAlert = (record) => {
        MySwal.fire({
            title: t?.[l]?.["are_you_sure?"] || "Are you sure?",
            text: t?.[l]?.["you_won't_be_able_to_revert_this!"] || "You won't be able to revert this!",
            showCancelButton: true,
            confirmButtonColor: "#00ff00",
            confirmButtonText: t?.[l]?.["yes,_delete_it!"] || "Yes, delete it!",
            cancelButtonColor: "#ff0000",
            cancelButtonText: t?.[l]?.["cancel"] || "Cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                console.log('record._id',record);
                let result = await axios.post("removecardatascrapper/", {_id: record._id});
                console.log(result)
                dispatch(set_page_refresh("paymentConfigs"))
                MySwal.fire({
                title: t?.[l]?.["deleted!"] || "Deleted!",
                text: t?.[l]?.["item_has_been_deleted."] || "Item has been deleted.",
                className: "btn btn-success",
                confirmButtonText: t?.[l]?.["ok"] || "OK",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                }).then(() => {
                });
              } catch(e) {
                console.log(e)
                return false;
              }
              
            } else {
              MySwal.close();
            }
        });
    };

    
    return (
        <div>
            <div className={`${l === 'ar' ? 'page-wrapper-rtl' : 'page-wrapper'}`}>
                <div className="content">
                    <div className="page-header">
                        <div className="add-item d-flex">
                            <div className="page-title">
                                <h4>{t?.[l]?.["car_scrapper_configuration"] || "Car Scrapper Configuration"}</h4>
                                <h6>{t?.[l]?.["manage_car_scrapper_configuration"] || "Manage Car Scrapper Configuration"}</h6>
                            </div>
                        </div>
              
                        {canCreate ? (
                        <div className="page-btn">
                            <Link
                                to="#"
                                className="btn btn-added"
                                data-bs-toggle="modal"
                                data-bs-target="#add-brand"
                                onClick={() => dispatch(set_gateway_edit({}))}
                            >
                                <PlusCircle className="me-2" />
                                {t?.[l]?.["add_car_scrapper_configuration"] || "Add Car Scrapper Configuration"}
                            </Link>
                        </div>
                          ) : null}
                    </div>
                    {/* /product list */}
                    <div className="card table-list-card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <Table2 columns={columns} dataSource={dataSource} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddTaacaaIntegration />
        </div>
    )
}

export default TaacaaIntegration;